/**
 * Created by renatolovizotto on 04/07/17.
 */
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {Loader} from '../components/Loader';
import '../assets/stylesheets/Player.scss';


@inject('Navigator', 'AuthStore', 'PlayerStore', 'ConfigStore')
@observer
export default class Player extends Component {

    constructor(props) {
        super(props);

        this.state = {
            bookHTML: '',
            timerOn: false,
            gameOn: false,
        }
    }

    componentWillMount() {
        this.props.PlayerStore.loadBookHTML();
    }

    handleScrollContents(e) {
        this._loadTimer(e.currentTarget.scrollTop > 1500 && e.currentTarget.scrollTop < 3800);
        this._loadGame(e.currentTarget.scrollTop > 4000 && e.currentTarget.scrollTop < 5500);
    }

    _loadTimer(on) {
        this.setState({timerOn: on});
    }

    _loadGame(on) {
        this.setState({gameOn: on});
    }

    closePlayer() {
        this.props.ConfigStore.animationType = 'bottom';
        this.props.Navigator.goBack();
    }

    render() {

        const {
            timerOn,
            gameOn
        } = this.state;

        return (
            <div className="Player Page">
                {
                    this.props.PlayerStore.isLoading
                        ? <Loader inverted/>
                        : <div className="container"
                               dangerouslySetInnerHTML={{__html: this.props.PlayerStore.bookHTML}}
                               onScroll={this.handleScrollContents.bind(this)}
                    />
                }
                <div className={"timer-container" + (timerOn ? " on" : "")}>
                    <div className="timer">

                    </div>
                </div>
                <div className={"game-container" + (gameOn ? " on" : "")}>
                    <div className="game">
                        <h1>Init the Game</h1>
                        <div className="">
                            Curitiba (Tupi: "Pine Nut Land", Portuguese pronunciation: [kuɾiˈtʃibɐ]) is the capital and
                            largest city of the Brazilian state of Paraná. The city's population numbered approximately
                            1,879,355 people as of 2015, making it the eighth most populous city in the country, and the
                            largest in Brazil's South Region. The Curitiba Metropolitan area comprises 26
                            municipalities[2] with a total population of over 3.2 million (IBGE estimate in 2010),[3]
                            making it the seventh most populous in the country.
                        </div>
                    </div>
                </div>
                <div className="btn-close-book" onClick={this.closePlayer.bind(this)}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Player.js